import { render } from "./XIconSolidUsers.vue?vue&type=template&id=b06b572e"
import script from "./XIconSolidUsers.vue?vue&type=script&lang=js"
export * from "./XIconSolidUsers.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/pointra/manager/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"XIconSolidUsers.vue"]])

export default __exports__